import { Account } from './account.types';
import { Address } from '../common.types';
import { ImageInputEvent } from '../components/image-input/image-input.types';
import { AdvertiserTypes } from '../types/advertiser.types';

export interface ICreateAccountForm {
  val: ICreateAccount;
  isFormValid: boolean;
}

/**
 * @todo Extract this type to shared module
 */
export interface ICreateAccount extends ICreateAccountRaw {
  accountType: Account.Type;
  logo?: ImageInputEvent;
  bannersEnabled?: boolean;
}

export interface ICreateAccountRaw {
  id: string,

  name: string;
  domain: string;
  currency: string;

  companyNIP: string;
  companyName: string;
  mobilePhone: string;
  email: string;

  address: Address;
  correspondenceAddress: Address;
  showCorrespondenceAddress: boolean;
  shoppingPlatform: string;

  logoId?: string;
  whiteLabel?: string;
  selfAdvertiser?: boolean;
  advertiserType?: AdvertiserTypes;
  organizationId?: string;
}

export const EMPTY_ACCOUNT: ICreateAccount = {
  id: '',
  accountType: Account.Type.ADVERTISER,
  name: '',
  domain: '',
  currency: 'PLN',

  companyNIP: '',
  companyName: '',
  mobilePhone: '',
  email: '',
  address: new Address('PL'),
  correspondenceAddress: new Address('PL'),
  showCorrespondenceAddress: false,
  shoppingPlatform: 'magento'
};
